import { createNoAuthenticationClient } from "@/http-client";
import { AxiosInstance, AxiosResponse } from 'axios';
import { Skill } from '@/models/Skill';
import { prefixBaseUrlOneApi, getBaseUrlOneApi } from "@/helper";

export class SkillService {

    constructor(private client: AxiosInstance) {
        this.client = client;
    }


    async getTechSkillsByName(name: string): Promise<AxiosResponse> {
        if(name != null && name != ""){
            const result = await this.client.get(prefixBaseUrlOneApi + "/skills/byBrand/" + encodeURIComponent(name) + "/tech", { baseURL: getBaseUrlOneApi() });
            result.data = { data: result.data, total: result.data.length };
            return result;
        }
        else{
            const result = await this.getByBrand(1);
            result.data = { data: result.data, total: result.data.length };
            return result;
        }

    }

    async getFinanceSkillsByName(name: string): Promise<AxiosResponse> {
        const result = await this.client.get(prefixBaseUrlOneApi + "/skills/byBrand/" + encodeURIComponent(name) + "/finance", { baseURL: getBaseUrlOneApi() });
        result.data = { data: result.data, total: result.data.length };
        return result;
    }

    async get(): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/skills/", { baseURL: getBaseUrlOneApi() });
    }
    async getAll(): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/skills/", { baseURL: getBaseUrlOneApi() });
    }
    async getByBrand(brandId: number): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/skills/byBrand/" + brandId, { baseURL: getBaseUrlOneApi() });
    }
}

export async function createSkillService(): Promise<SkillService> {
    const client = await createNoAuthenticationClient();

    return new SkillService(client);
}
